import { Box } from '@mui/material';
import { memo, ReactNode } from 'react';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  content: {
    height: '100%',
    width: '100%',
    position: 'relative'
  }
}));

interface Props {
  children: ReactNode;
}

const WithLayout = ({ children }: Props) => {
  const classes = useStyles();

  return <Box className={classes.content}>{children}</Box>;
};

export default memo(WithLayout);
